export async function onCustomerPortal(customerid) {
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "content-type": "application/json",
    accept: "application/json",
    "Cache-Control": "no-cache",
  };

  //api/checkout/users.uid/priceid/submissionID/price
  const response = await fetch(`/api/portal/${customerid}`, {
    method: "GET",
    headers,
  });

  const result = await response.json();
  console.log(result);

  if (result.hasOwnProperty("sessionUrl")) {
    return result;
  } else {
    throw Error(JSON.stringify(result));
  }
}
